import {
    getWorkSheetList,   
    SaveWorkSheet,
    SaveWorkSheetMain,
    SaveWorkSheetSub,
    SaveWorkSheetSub2024,
    Save21VResult,
    getDDLList,
    AnalisysSurvey,
    exportWorkSheetList,
    GetWorkSheetDetail_Advance,
    GetInfoList,
    GetRenewLogList,
    ImportRenewOrderExcel2Tmp,
    GetRenewOrderList,
    // getSheetCode,
} from '@/api/workSheet'
import {getToken, removeToken, setToken} from '@/utils/auth'
import {resetRouter} from '@/router'
import {generateDepartmentList, generateSlideData} from "@/utils/data-generator";
import {formatDataToSever,createsheetTypeIdsFromSever,getSampleStrToSever,getSampleLogStrToSever} from "@/views/WorkSheet/xml-manager";
import {encrypt} from "@/utils/encrypt";

// 用户记录
const state = {
    workSheetList: [],
    typeList:[],
    infotypeList:[],
    statusList:[],
    groupUserList:[],
    gradeList:[],
    cate21VList:[],
    AnalisysSurveySet:[],
    GetWorkSheetDetail_Advance:[],
    // sheetCode:[],
    infoList:[],
    renewLogList:[],
    importRenewOrderExcel2Tmp:[],
    renewOrderList:[],
};

const mutations = {    
    workSheetList: (state, list) => {
        state.workSheetList = list;
    },
    infoList: (state, list) => {
        state.infoList = list;
    },
    typeList: (state, list) => {
        // console.log('typelist',list)
        state.typeList = list;
    },
    infotypeList: (state, list) => {
        // console.log('typelist',list)
        state.infotypeList = list;
    },
    statusList: (state, list) => {
        state.statusList = list;
    },
    groupUserList: (state, list) => {
        state.groupUserList = list;
    },
    gradeList: (state, list) => {
        state.gradeList = list;
    },
    cate21VList: (state, list) => {
        state.cate21VList = list;
    },
    AnalisysSurveySet: (state, list) => {
        state.AnalisysSurveySet = list;
    },
    GetWorkSheetDetail_Advance: (state, list) => {
        console.log('aaaaaa',list)
        state.GetWorkSheetDetail_Advance = list;
    },
    renewLogList: (state, list) => {
        state.renewLogList = list;
    },
    importRenewOrderExcel2Tmp: (state, list) => {
        state.importRenewOrderExcel2Tmp = list;
    },
    renewOrderList: (state, list) => {
        state.renewOrderList = list;
    },
    // sheetCode: (state, list) => {
    //     state.sheetCode = list;
    // },
}

const actions = {

    async workSheetList({commit, state},{sDate='',eDate='',typeIds='',statusId='',menuModuleId=0, key = '',onlyTo21V=false}) {
        // console.log('abc')
        return getWorkSheetList({userId: getToken(),sDate,eDate,typeIds,statusId,menuModuleId,key,onlyTo21V}).then(response => {
            commit('workSheetList', response.data);
        });
    },
    async infoList({commit, state},{sDate='',eDate='',typeIds='', key = ''}) {
        return GetInfoList({userId: getToken(),sDate,eDate,typeIds,key}).then(response => {
            commit('infoList', response.data);
        });
    },
    async typeList({commit, state},{userId}) {
        // console.log('abc',userId)
        // if (!userId){
        //     userId = getToken()
        // }
        return getDDLList({userId,type:'工单类型'}).then(response => {
            commit('typeList', response.data);
        });
    },
    async infotypeList({commit, state},) {
        return getDDLList({userId: getToken(),type:'知识分类'}).then(response => {
            commit('infotypeList', response.data);
        });
    },
    async statusList({commit, state},{userId}) {
        if (!userId){
            userId = getToken()
        }
        return getDDLList({userId,type:'工单状态'}).then(response => {
            commit('statusList', response.data);
        });
    },
    async groupUserList({commit, state},{userId}) {
        if (!userId){
            userId = getToken()
        }
        return getDDLList({userId,type:'用户'}).then(response => {
            commit('groupUserList', response.data);
        });
    },
    async gradeList({commit, state},{userId}) {
        if (!userId){
            userId = getToken()
        }
        return getDDLList({userId,type:'紧急程度'}).then(response => {
            commit('gradeList', response.data);
        });
    },
    async cate21VList({commit, state},{userId}) {
        if (!userId){
            userId = getToken()
        }
        return getDDLList({userId,type:'21V分类'}).then(response => {
            commit('cate21VList', response.data);
        });
    },
    async renewLogList({commit, state},) {
        return GetRenewLogList({userId: getToken()}).then(response => {
            commit('renewLogList', response.data);
        });
    },
    async importRenewOrderExcel2Tmp({commit, state},{ym,formData}) {
        return ImportRenewOrderExcel2Tmp({userId: getToken(),ym,formData}).then(response => {
            commit('importRenewOrderExcel2Tmp', response.data);
        });
    },
    async renewOrderList({commit, state},{ym}) {
        return GetRenewOrderList({userId: getToken(),ym}).then(response => {
            commit('renewOrderList', response.data);
        });
    },
    // async sheetCode({commit, state},{}) {
    //     console.log('aa')
    //     return getSheetCode({userId: getToken()}).then(response => {            
    //         commit('sheetCode', response.data);
    //     });
    // },
    
    // id,
    // sessionCode,
    // sheetCode,
    // sheetTypeIds,
    // title,
    // content,
    // alertLevel,
    // status
    async SaveWorkSheet({commit, state}, {form}) {
        var p={userId: encrypt(getToken()),
                ...formatDataToSever(form)};
        return SaveWorkSheet({
            p
        }).then(response => {
            // commit('SET_USER_LIST_ITEM', response.data[0]);
        });

    },
    async SaveWorkSheetMain({commit, state}, {form}) {
        const {id,sessionCode,sheetCode,sheetTypeIds,title,content,alertLevel,sample
            ,companyType,companyName,jxsName,contactUser,tel,address,email,account,userId
            // ,to21V,cateId,code21V,result21Vm,sample21VLog
        } = form;

        var p={userId: encrypt(userId),
                id,
                sessionCode, 
                sheetCode,                
                title,
                content,
                ...createsheetTypeIdsFromSever({sheetTypeIds}),
                sample: getSampleStrToSever({sample}),
                alertLevel,
                companyType,companyName,jxsName,contactUser,tel,address,email,account
                // ,to21V,cateId,code21V,result21Vm,sample21VLog:getSampleStrToSever({sample21VLog})
                // ...formatMainDataToSever(form)
                // ...form
            };
        return SaveWorkSheetMain({
            p
        }).then(response => {
            // commit('SET_USER_LIST_ITEM', response.data[0]);
        });

    },

    async SaveWorkSheetSub({commit, state}, {logId,wsId,toUIds,ccUIds,finished,itemContent,sampleLog}) {
        var p={
            userId: encrypt(getToken()),
            logId,
            wsId, 
            toUIds,
            ccUIds,
            finished,                
            itemContent,   
            sampleLog: getSampleLogStrToSever({sampleLog}),            
            };
        return SaveWorkSheetSub({
            p
        }).then(response => {
            // commit('SET_USER_LIST_ITEM', response.data[0]);
        });

    },

    async Save21VResult({commit, state}, {logId,result21V,userId}) {
        var p={
            userId: encrypt(userId),
            logId,
            result21V            
        };
        return Save21VResult({
            p
        }).then(response => {
            // commit('SET_USER_LIST_ITEM', response.data[0]);
        });

    },

    async SaveWorkSheetSub2024({commit, state}, {logId,wsId,toUIds,ccUIds,finished,itemContent,sampleLog
        ,to21V,cateId,code21V,result21V,sample21VLog,userId}) {
        var p={
            userId: encrypt(userId),
            logId,
            wsId, 
            toUIds,
            ccUIds,
            finished,                
            itemContent,   
            sampleLog: getSampleLogStrToSever({sampleLog}),
            to21V,cateId,code21V,result21V,sample21VLog:getSampleLogStrToSever({sampleLog:sample21VLog}),            
        };
        return SaveWorkSheetSub2024({
            p
        }).then(response => {
            // commit('SET_USER_LIST_ITEM', response.data[0]);
        });

    },

    async AnalisysSurveySet({commit, state},{sDate='',eDate='',typeIds=''}) {
        return AnalisysSurvey({userId: getToken(),sDate,eDate,typeIds}).then(response => {
            commit('AnalisysSurveySet', response.data);
        });
    },

    async exportWorkSheetList({commit}, {sDate,eDate}) {
        return exportWorkSheetList({
            userId: getToken(),sDate,eDate
            
        });
    },

    async GetWorkSheetDetail_Advance({commit}, {sheetCode}) {
        // console.log('sdad')
        return GetWorkSheetDetail_Advance({userId: getToken(),sheetCode}).then(response => {
            commit('GetWorkSheetDetail_Advance', response.data);
        });

    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
